import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { AxlPanel, AxlButton, AxlModal, Colors } from 'axl-reactjs-ui';

// Utils

// Styles
import styles from './styles';

export default class ShipmentPickupInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      arrow: true
    }
  }

  componentDidMount() {
    if(this.props.arrow !== undefined) {
      this.setState({arrow: this.props.arrow});
    }
  }

  render() {
    const { arrow } = this.state;
    const { pickup, dropoff, shipment, item, isEdit, isBlur } = this.props;
    const COMPLETED = ['SUCCEEDED', 'FAILED'];
    const pickupStatus = (shipment && shipment.status) ? shipment.status : null
    const statusColor = pickupStatus ? styles.Status[pickupStatus] : styles.Status['DEFAULT'];
    const dtFormat = moment(shipment.dropoff_latest_ts).isBefore(moment()) ? 'MM/DD hh:mm A' : 'hh:mm A'
    const isPickupError = !shipment.pickup_address.lat || !shipment.pickup_address.lng;

    return  <AxlPanel style={styles.panelContainer}>
      <div style={styles.panelHeader}>
        <div style={styles.panelHeaderTitle}>{`Pickup Info:`}</div>
      </div>
      <AxlPanel.Row style={styles.panelContent}>
        <AxlPanel.Col flex={1}>
          <AxlPanel.Row style={styles.row}>
            <AxlPanel.Col>
              <div style={{...styles.text, ...{color: isPickupError ? 'red' : '#000'}, ...(isBlur && styles.textBlur)}}>
                <div>{shipment.pickup_address.street}</div>
                <div>{shipment.pickup_address.street2}</div>
                <div>{shipment.pickup_address.city}, {shipment.pickup_address.state} {shipment.pickup_address.zipcode}</div>
              </div>
            </AxlPanel.Col>
            { shipment.pickup_note && <AxlPanel.Col>
              <div style={styles.noteLabel}>{`NOTES`}</div>
              <div style={styles.noteContent}>{shipment.pickup_note}</div>
            </AxlPanel.Col>}
          </AxlPanel.Row>
        </AxlPanel.Col>
      </AxlPanel.Row>
    </AxlPanel>
  }
}
